const countries = state => state.countries;

export {
  countries,
}